import React from "react";
import type { RightDrawerContentType } from "@/components/feature/layout/right-sidebar/rightDrawer";
import { CitationInfo, type FileItem, type FolderItem } from "@/views/chat/types";

export interface CurrentPdfContextType {
  currentPdfId: string | null;
  setCurrentPdfId: (id: string | null) => void;
  isRightDrawerVisible: boolean;
  setIsRightDrawerVisible: (visible: boolean) => void;
  rightDrawerContent: RightDrawerContentType;
  setRightDrawerContent: (content: RightDrawerContentType) => void;
  handleCitationClick: (citation: CitationInfo) => void;
  currentCitation: CitationInfo | null;
  setCurrentCitation: (citation: CitationInfo | null) => void;
  handleFileSelect: (file: FileItem, isSelected: boolean) => void;
  setSelectedFiles: (files: string[]) => void;
  selectedFiles: string[];
  setRootItem: (item: FolderItem | FileItem) => void;
  rootItem: FolderItem | FileItem | undefined;
}

export const CurrentPdfContext = React.createContext<CurrentPdfContextType | undefined>(undefined);
